import React, { FC } from 'react';
import Lottie from 'react-lottie';

import Styled from './styles';
import store from '../../assets/images/app-store.png';
import logo from '../../assets/images/black-logo-text.png';
import animationData from '../../assets/lottie/Loginscreen.json';

export const AuthWrapper: FC<any> = ({ children }) => {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
	};

	return (
		<Styled.Wrapper>
			<Styled.Left>
				<Styled.Top>
					<Styled.Logo src={logo} alt="" />
				</Styled.Top>
				<div style={{ flex: 2 }}>{children}</div>
			</Styled.Left>
			<Styled.Right>
				<Lottie
					options={defaultOptions}
					style={{ maxHeight: 800 }}
					isStopped={false}
					isPaused={false}
				/>
				<img
					src={store}
					style={{
						width: 160,
						zIndex: 2,
						position: 'absolute',
						bottom: 30,
						left: 40,
					}}
					alt=""
				/>
			</Styled.Right>
		</Styled.Wrapper>
	);
};
